module.exports = __webpack_public_path__ + "static/media/ME.920d0109.png";